export default __webpack_public_path__ + "static/media/Honored Gauntlets of the Four Winds.e58429a3.jpg";